import { Col, FormGroup, Input, Label, Row } from '@polichat/flamboyant';
import { useState } from 'react';
import { useGlotaT } from '../../../../../../hooks/useGlotaTranslation';
import {
  LabelWithSpan,
  OptionsContainer,
} from '../../FormMessagesBuilder.styles';

function CreateFooterList({ onUpdate, initialValue, isEdit }) {
  const [footerData, setFooterData] = useState(initialValue);

  // Traduções
  const footerLabel = useGlotaT('spa.messageBuilder.list.footer.label');
  const footerDescription = useGlotaT('spa.messageBuilder.list.footer.description');
  const footerPlaceholder = useGlotaT('spa.messageBuilder.list.footer.placeholder');

  const handleInputChange = ({ target: { name, value } }) => {
    setFooterData({
      ...footerData,
      [name]: value,
    });
    handleFooterData({
      ...footerData,
      [name]: value,
    });
  };

  const handleFooterData = (data) => {
    onUpdate(data);
  };

  return (
    <Row>
      <Col sm={12}>
        <FormGroup>
          <LabelWithSpan>
            <Label>
              {footerLabel}:{' '}
              <span>
                {footerDescription}{' '}
              </span>
            </Label>
          </LabelWithSpan>
          <Input
            type="text"
            id="footer-message"
            name="text"
            placeholder={footerPlaceholder}
            value={footerData.text}
            onChange={handleInputChange}
            showCharCounter
            maxLength={60}
            disabled={isEdit}
          />
          <OptionsContainer></OptionsContainer>
        </FormGroup>
      </Col>
    </Row>
  );
}

export default CreateFooterList;
